import React, { createContext, useContext, useState, useCallback, useMemo, useEffect } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "it";
    const stored = window.localStorage.getItem("proscenio.lang");
    if (stored === "it" || stored === "en") return stored;
    const browser = (navigator.language || "it").toLowerCase();
    return browser.startsWith("it") ? "it" : "en";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("proscenio.lang", lang);
      document.documentElement.lang = lang;
    } catch (_) {}
  }, [lang]);

  const toggle = useCallback(() => {
    setLang((l) => (l === "it" ? "en" : "it"));
  }, []);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggle,
      t: translations[lang],
    }),
    [lang, toggle]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
